import styled from 'styled-components';

import { ANALYTICS_EVENTS } from '@nandosaus/constants';
import { analytics } from '../../analytics';
import { breakpoints } from '../../constants';
import { Flex } from '../grid';
import { NavLink } from '../nav-link';
import { P } from '../typography/new';
import { useNavigationItems } from '../../hooks/use-navigation-items';

const CURRENT_YEAR = new Date().getFullYear();

// styles must sit above component to prevent babel-loader error
const Wrapper = styled(Flex)`
  flex-direction: column;

  @media (min-width: ${breakpoints.lg}) {
    flex-direction: row;
  }
`;

const SecondaryNavigation = () => {
  const footerNavigationItems = useNavigationItems('footer');

  return (
    <Wrapper alignItems="center" flexWrap="wrap" mb={{ xs: '64px', lg: '120px' }}>
      <Flex gap={{ _: '16px' }} flexWrap="wrap">
        {footerNavigationItems.map(({ label, href }) => (
          <NavLink
            onClick={() => {
              analytics.track(ANALYTICS_EVENTS.FOOTER_NAV_ITEM_CLICKED, {
                text: label,
              });
            }}
            href={href}
            key={href}
            style={{ color: 'white' }}
          >
            <P variant="extra-small">{label}</P>
          </NavLink>
        ))}
        <P variant="extra-small" color="white">
          © Copyright Nando&apos;s {CURRENT_YEAR}
        </P>
      </Flex>
    </Wrapper>
  );
};

export { SecondaryNavigation };
